import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const QUERY = gql`
  query getProducts($request: CriteriaRequest!) {
    products(request: $request) {
      content {
        id
        name
        sku
        physical
        attributes {
          code
          value
        }
        variants {
          price
          name
          type
          attributes {
            code
            value
          }
        }
        media {
          type
          url
        }
        cartAddable {
          addable
          message
        }
        set
        products {
          id
          name
          sku
          attributes {
            code
            value
          }
          variants {
            price
            name
            type
            attributes {
              code
              value
            }
          }
          cartAddable {
            addable
            message
          }
        }
        inventoryCount
      }
      totalPages
      totalElements
      page
      size
      filters {
        type
        name
        items {
          name
          value
          total
        }
      }
      sorts {
        name
        value
      }
    }
  }
`;

const useProducts = ({ conditions, page, size, sort = '' }) => {
  const criteria = conditions || [];

  const request = {
    page,
    sort,
    size,
    criteria,
  };

  return useQuery(QUERY, { variables: { request }, fetchPolicy: 'no-cache' });
};

export default useProducts;
